import ChartTab from "./ChartTab";
import React from "react";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";

class ChartTiersTabPure extends React.Component {
  render() {
    const { data } = this.props;

    const defaultPageSize = computeDefaultTableSize(data, "tiers.name");

    const columnName = this.props.customColumnName
      ? this.props.customColumnName
      : "tiers";

    let pivots = ["tiers", "category", "project"]; //, "previous_quantity", "current_quantity"];
    let showColumns = [columnName, "category", "project", "hiddenSeller"];

    if (
      this.props.showProductColumn === undefined ||
      this.props.showProductColumn === true
    ) {
      //show product by default
      pivots.push("product");
      showColumns.push("product");
    }

    return (
      <ChartTab
        {...this.props}
        data={data}
        min
        defaultPageSize={defaultPageSize}
        pivots={pivots}
        showColumns={showColumns}
        showPagination={false}
        showDetails={false}
        showQuantityDetails={true}
        showExtra={true}
        defaultSorted={[
          {
            id: "tiers",
            desc: false
          }
        ]}
      />
    );
  }
}

export default ChartTiersTabPure;
